<template>
    <header class="header">
      <div class="container header-container">
        <div class="logo">
          <router-link to="/">
            <h1>  @all </h1>
          </router-link>
        </div>
        
        <!-- Hamburger button for mobile -->
        <button class="hamburger-btn" @click="toggleMobileMenu" :class="{ active: isMobileMenuOpen }">
          <span></span>
          <span></span>
          <span></span>
        </button>
        
        <!-- Navigation menu -->
        <nav class="nav" :class="{ 'mobile-open': isMobileMenuOpen }">
          <router-link to="/" exact @click="closeMobileMenu">Home</router-link>
          <router-link to="/concept" @click="closeMobileMenu">Concept</router-link>
          <router-link to="/introduction" @click="closeMobileMenu">Artworks</router-link>
          <router-link to="/artists" @click="closeMobileMenu">Artists</router-link>
          <router-link to="/virtual-exhibition" @click="closeMobileMenu">Virtual Exhibition</router-link>
          <router-link to="/visit" @click="closeMobileMenu">Visit</router-link>
          <router-link to="/game" @click="closeMobileMenu">Game</router-link>
        </nav>
      </div>
    </header>
  </template>
  
  <script>
  export default {
    name: 'AppHeader',
    data() {
      return {
        isMobileMenuOpen: false
      }
    },
    methods: {
      toggleMobileMenu() {
        this.isMobileMenuOpen = !this.isMobileMenuOpen
      },
      closeMobileMenu() {
        this.isMobileMenuOpen = false
      }
    },
    watch: {
      // Close mobile menu automatically when route changes
      '$route'() {
        this.isMobileMenuOpen = false
      }
    },
    mounted() {
      // Close mobile menu when clicking outside
      document.addEventListener('click', (e) => {
        if (!this.$el.contains(e.target)) {
          this.isMobileMenuOpen = false
        }
      })
    }
  }
  </script>
  
  <style scoped>
  .header {
    background-color: transparent;
    position: fixed;
    top: 0;
    z-index: 100;
    box-shadow: none;
    width: 100%;
    margin: 0;
    padding: 0;
  }
  
  .header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0;
    margin: 0;
    width: 100%;
    position: relative;
  }
  
  .logo {
    margin-left: 20px;
  }
  
  .logo h1 {
    font-size: 24px;
    font-weight: bold;
    margin: 0;
    color: #004D6B;
  }
  
  .nav {
    display: flex;
    gap: 20px;
  }
  
  .nav a {
    color: #004D6B;
    font-weight: 500;
    padding: 8px 15px;
    border-radius: 50px;
    transition: all 0.3s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    background-color: rgba(255, 255, 255, 0.7);
    border: 1px solid rgba(0, 0, 0, 0.05);
    transform: translateY(0);
  }
  
  .nav a:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    transform: translateY(-2px);
    background-color: rgba(255, 255, 255, 0.9);
  }
  
  .nav a.router-link-active {
    color: #ffffff;
    background-color: rgba(240, 131, 30, 0.9);
    box-shadow: inset 4px 4px 8px rgba(0, 0, 0, 0.4),
                inset -4px -4px 8px rgba(255, 255, 255, 0.15);
    border: 1px solid rgba(255, 255, 255, 0.2);
    transform: translateY(1px);
  }

  /* Hamburger button styles */
  .hamburger-btn {
    display: none;
    flex-direction: column;
    justify-content: space-around;
    width: 30px;
    height: 30px;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
    margin-right: 20px;
    z-index: 101;
  }

  .hamburger-btn span {
    width: 30px;
    height: 3px;
    background-color: #004D6B;
    border-radius: 2px;
    transition: all 0.3s ease;
    transform-origin: center;
  }

  .hamburger-btn.active span:nth-child(1) {
    transform: rotate(45deg) translate(6px, 6px);
  }

  .hamburger-btn.active span:nth-child(2) {
    opacity: 0;
  }

  .hamburger-btn.active span:nth-child(3) {
    transform: rotate(-45deg) translate(7px, -6px);
  }
  
  @media (max-width: 768px) {
    .header-container {
      flex-direction: row;
      gap: 0;
    }
    
    .hamburger-btn {
      display: flex;
    }
    
    .nav {
      position: absolute;
      top: 100%;
      left: 0;
      width: 100%;
      background-color: rgba(255, 255, 255, 0.95);
      backdrop-filter: blur(10px);
      flex-direction: column;
      gap: 0;
      padding: 20px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
      border-top: 1px solid rgba(0, 0, 0, 0.1);
      transform: translateY(-100%);
      opacity: 0;
      visibility: hidden;
      transition: all 0.3s ease;
      z-index: 99;
    }
    
    .nav.mobile-open {
      transform: translateY(0);
      opacity: 1;
      visibility: visible;
    }
    
    .nav a {
      width: 100%;
      text-align: center;
      margin-bottom: 10px;
      padding: 15px;
      border-radius: 10px;
    }
    
    .nav a:last-child {
      margin-bottom: 0;
    }
  }
  </style>